import { createContext } from "react";
import FavoriteStore from "@state/stores/offer/shared/FavoritesStore";

export const FavoritesStoreContext = createContext({} as FavoriteStore);
